import React, {useState, useContext} from 'react'
import './Receipt.css'
import {PaymentContext} from '../../Context/PaymentContext'

/**
* @author
* @function Receipt
**/

const Receipt = (props) => {
const date = new Date()
const {userInfo, totalbilling, expiredTime, startTime} = useContext(PaymentContext)
const location = window.localStorage.getItem('lot')
const fullname = window.localStorage.getItem('fullname')
const license = window.localStorage.getItem('license')
const start_time = window.localStorage.getItem('startTime')
const endTime = window.localStorage.getItem('endTime')
const expired_time = window.localStorage.getItem('expTime')
const total = window.localStorage.getItem('total')
const taxPercentage = window.localStorage.getItem('taxPercentage')
const transactionFee = window.localStorage.getItem('transactionFee')
const data = `${date.getFullYear()}/${date.getMonth()}/${date.getUTCDate()}`
const number = window.localStorage.getItem('phone')
const parkTitle = window.localStorage.getItem('parkTitle')
const lotId = window.localStorage.getItem('lotId')
const reqId = window.localStorage.getItem('reqId')

const [status, setStatus] = useState(false)
const [receipStyling, setReceiptStyling] =useState({
wrapperStyling: {
    width: '60%',
    height: 'auto',
    backgroundColor: '#EEEEF1',
    position: 'absolute',
    color: '#848484',
    padding: '20px',
    zIndex: '20',
    marginTop: '-30%',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
    borderRadius: '21px'
}
})
const amountWithTax = parseFloat(total-transactionFee).toFixed(2);
const subtotal = parseFloat(amountWithTax / (1+(taxPercentage/100))).toFixed(2)
const tax = parseFloat(amountWithTax-subtotal).toFixed(2)

const text_data = {
    'name': fullname,
    'license_plate': license,
    'start_time': start_time,
    'exp_time': expired_time,
    'subtotal': subtotal,
    'total': total,
    'tax': tax,
    'price': subtotal,
    'transactionFee': transactionFee,
    'location': 'OneShot Parking',
    'lot': location,
    'date': data,
    'number': number
}


const send_receipt = () =>{
    fetch('https://osParking.pythonanywhere.com/send-receipt', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin':'*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(text_data)
    })
    .then((promise)=> promise.json())
    .then((data) => {
        setStatus(true)
    })
}

const downloadInvoice = async (reqId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_URL_ONESHOT}/v2/Park/GetInvoice?reqId=${reqId}`, {
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Accept': 'application/pdf',
        },
    });

    if (!response.ok) throw new Error('Failed to download')

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url

    // Try to get filename from header
    const disposition = response.headers.get('Content-Disposition') || ''
    let filename = 'invoice.pdf'

    // Try RFC 5987 (filename*=)
    const filenameStarMatch = disposition.match(/filename\*\=UTF-8''([^;\n]*)/)
    if (filenameStarMatch) {
        filename = decodeURIComponent(filenameStarMatch[1])
    } else {
        const filenameMatch = disposition.match(/filename="?([^"]+)"?/)
        if (filenameMatch) {
            filename = filenameMatch[1]
        }
    }

    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download failed', error)
  }
}

return(
    <div style={receipStyling.wrapperStyling}>
        <div className='exit_container'>
            <button className='close_receipt_btn' onClick={props.close}>X</button>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Name:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px'}}>{fullname}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>License Plate:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px'}}>{license}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Start Time:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px' }}>{start_time.split('T')[0]} {start_time.split('T')[1].slice(0,5)}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Expired Time:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px'}}>{endTime.split('T')[0]} {endTime.split('T')[1].slice(0,5)}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Price:</h4>
            <p style={{marginLeft:   '20px', marginBottom: '0px'}}>${subtotal}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Tax:</h4>
            <p style={{marginLeft:   '20px', marginBottom: '0px'}}>${tax}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Transaction Fee:</h4>
            <p style={{marginLeft:   '20px', marginBottom: '0px'}}>${transactionFee}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Total:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px'}}>${total}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Lot ID:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px'}}>{lotId}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>Location:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px'}}>{parkTitle}</p>
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <h4 style={{marginBottom: '0px'}}>TAX ID:</h4>
            <p style={{marginLeft: '20px', marginBottom: '0px'}}>837235373</p>
        </div>
        {/*<div style={{display: 'flex', alignItems: 'center'}}>*/}
        {/*    <h4 style={{marginBottom: '0px'}}>Date:</h4>*/}
        {/*    <p style={{marginLeft: '20px', marginBottom: '0px'}}></p>*/}
        {/*</div>*/}
        <button onClick={() => downloadInvoice(reqId)} style={ status?{backgroundColor: 'green', color: 'white'}: {}} className='Send_receipt_copy'>
            Download
        </button>

    </div>
   )

 }

export default Receipt
